import { collection, getDocs, updateDoc, doc } from 'firebase/firestore';
import { db } from '../config/firebase';

export const updateExistingBillsWithClientCompanyName = async () => {
  try {
    console.log('Updating existing bills with clientCompanyName field...');

    const billsRef = collection(db, 'bills');
    const snapshot = await getDocs(billsRef);

    const updatePromises = snapshot.docs.map(async (billDoc) => {
      const billData = billDoc.data();

      // Check if clientCompanyName field exists
      if (!billData.clientCompanyName && billData.clientName) {
        console.log(`Updating bill ${billDoc.id} with clientCompanyName: ${billData.clientName}`);

        return updateDoc(doc(db, 'bills', billDoc.id), {
          clientCompanyName: billData.clientName,
          updatedAt: new Date().toISOString()
        });
      }

      return Promise.resolve();
    });

    await Promise.all(updatePromises);
    console.log('Successfully updated all existing bills with clientCompanyName field');
  } catch (error) {
    console.error('Error updating existing bills:', error);
  }
};
